import React, { useState } from "react";
import { Phone, Mail, X, Plus } from "lucide-react";
import { useSite, waLink } from "@/context/SiteContext";
import { trackEvent } from "@/lib/api";

function WhatsAppIcon({ size = 30 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.885-9.885 9.885M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.892c0 2.096.549 4.142 1.595 5.945L0 24l6.335-1.652a12.062 12.062 0 005.71 1.447h.005c6.585 0 11.946-5.335 11.949-11.893a11.821 11.821 0 00-3.484-8.413Z" />
    </svg>
  );
}

export default function FloatingActions({ waMessage }) {
  const { settings } = useSite();
  const [open, setOpen] = useState(false);
  const msg = waMessage || "Hi Dreamzz HR & Consultancy, I would like to know more about your services.";

  return (
    <div className="fixed bottom-20 md:bottom-6 right-4 z-40 flex flex-col items-end gap-3">
      {open && (
        <div className="flex flex-col items-end gap-3 animate-fadeUp">
          <a href={`tel:${settings.phone}`} onClick={() => trackEvent("phone_click")} data-testid="float-call"
            className="group flex items-center gap-2" aria-label="Call us">
            <span className="text-xs font-semibold bg-white text-slate-700 px-2.5 py-1 rounded-lg shadow-md">Call Now</span>
            <span className="grid place-items-center h-12 w-12 rounded-full bg-brand-blue text-white shadow-lg ring-2 ring-white/70 group-hover:scale-110 transition-transform">
              <Phone size={20} fill="currentColor" strokeWidth={0} />
            </span>
          </a>
          <a href={`mailto:${settings.email}`} onClick={() => trackEvent("email_click")} data-testid="float-email"
            className="group flex items-center gap-2" aria-label="Email us">
            <span className="text-xs font-semibold bg-white text-slate-700 px-2.5 py-1 rounded-lg shadow-md">Email Us</span>
            <span className="grid place-items-center h-12 w-12 rounded-full bg-brand-gold text-white shadow-lg ring-2 ring-white/70 group-hover:scale-110 transition-transform">
              <Mail size={20} />
            </span>
          </a>
        </div>
      )}
      <a href={waLink(settings.whatsapp, msg)} target="_blank" rel="noreferrer"
        onClick={() => trackEvent("whatsapp_click", { message: msg })} data-testid="float-whatsapp"
        className="group flex items-center gap-2" aria-label="Chat with us on WhatsApp">
        <span className="hidden sm:block text-xs font-semibold bg-white text-[#128C7E] px-3 py-1.5 rounded-lg shadow-md">Chat with us</span>
        <span className="relative grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-xl ring-2 ring-white/70 group-hover:scale-110 transition-transform animate-floaty">
          <WhatsAppIcon size={30} />
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
        </span>
      </a>
      <button onClick={() => setOpen((o) => !o)} data-testid="float-toggle"
        className="grid place-items-center h-11 w-11 rounded-full glass-strong text-slate-600 shadow-lg hover:scale-110 transition-transform"
        aria-label="More contact options">
        {open ? <X size={20} /> : <Plus size={20} />}
      </button>
    </div>
  );
}
